import React from "react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

const ThankYou = () => {
  return (
    <div className="App" data-testid="thank-you-page">
      <Header onRegister={() => {}} />
      <main>
        <section
          className="pt-36 pb-24 md:pt-44 md:pb-32 bg-alabaster relative"
          data-testid="thank-you-section"
        >
          <div className="max-w-3xl mx-auto px-6 md:px-12 text-center">
            {/* Tick */}
            <div className="flex justify-center fade-up">
              <svg
                width="64"
                height="64"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <circle
                  cx="12"
                  cy="12"
                  r="11"
                  stroke="var(--gold-deep)"
                  strokeWidth="0.6"
                />
                <path
                  d="M7.5 12.5 L10.5 15.5 L16.5 9"
                  stroke="var(--gold-deep)"
                  strokeWidth="1"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  fill="none"
                />
              </svg>
            </div>

            <p
              className="mt-8 eyebrow fade-up delay-100"
              style={{ fontSize: "0.78rem", letterSpacing: "0.4em" }}
              data-testid="thank-you-eyebrow"
            >
              Your Seat Is Saved
            </p>

            <p
              className="mt-3 eyebrow fade-up delay-150"
              style={{ fontSize: "0.78rem", letterSpacing: "0.4em" }}
              data-testid="thank-you-for-label"
            >
              For
            </p>

            <h1
              className="mt-4 font-serif fade-up delay-200 leading-none balance"
              style={{
                color: "var(--ink)",
                fontSize: "clamp(2.6rem, 6vw, 5rem)",
                lineHeight: 1.05,
                fontWeight: 500,
              }}
              data-testid="thank-you-headline"
            >
              Do Less.{" "}
              <em
                className="font-serif italic"
                style={{ color: "var(--gold-deep)", fontWeight: 500 }}
              >
                Be More.
              </em>
            </h1>

            <p
              className="mt-6 font-serif italic fade-up delay-300"
              style={{
                color: "var(--gold-deep)",
                fontSize: "clamp(1.1rem, 1.5vw, 1.4rem)",
              }}
              data-testid="thank-you-event-details"
            >
              Wednesday 18th June &nbsp;·&nbsp; 7pm BST &nbsp;·&nbsp; Live on Zoom
            </p>

            {/* Private call CTA — moved high so it's seen quickly */}
            <div className="mt-10 max-w-xl mx-auto fade-up delay-350" data-testid="thank-you-call-block">
              <p
                className="text-center pretty"
                style={{
                  color: "var(--ink-soft)",
                  fontSize: "1.1rem",
                  lineHeight: 1.65,
                }}
              >
                If you can&apos;t wait until the masterclass and want to
                explore what&apos;s possible for you{" "}
                <em style={{ color: "var(--ink)" }}>now</em>, you can book a
                private call with me.
              </p>

              <div className="mt-6 flex justify-center">
                <a
                  href="https://calendly.com/persephonedennis/working-with-persephone"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-primary"
                  data-testid="thank-you-call-cta"
                >
                  Book A Private Call
                </a>
              </div>
            </div>

            {/* Zoom note */}
            <div
              className="mt-12 mx-auto max-w-xl px-6 py-5 fade-up delay-400"
              style={{
                background: "rgba(245, 230, 200, 0.55)",
                border: "1px solid var(--border-soft)",
              }}
              data-testid="thank-you-zoom-note"
            >
              <p
                className="text-[color:var(--ink-soft)]"
                style={{ fontSize: "1rem" }}
              >
                Your{" "}
                <strong style={{ color: "var(--gold-deep)" }}>Zoom link</strong>{" "}
                has been sent to your inbox &nbsp;—&nbsp; keep it safe so you
                don&apos;t lose it on the day.
              </p>
              <p
                className="mt-3 italic"
                style={{ color: "var(--gold-deep)", fontSize: "0.9rem" }}
              >
                Please check your spam or junk folder if you don&apos;t see it
                within a few minutes, and mark it as &ldquo;Not Junk&rdquo;.
              </p>
            </div>

            {/* Letter body */}
            <div
              className="mt-14 max-w-2xl mx-auto text-left space-y-7 fade-up delay-500"
              style={{
                fontSize: "1.1rem",
                color: "var(--ink-soft)",
                lineHeight: 1.75,
              }}
              data-testid="thank-you-letter"
            >
              <p
                className="font-serif italic text-center pt-2"
                style={{
                  color: "var(--ink)",
                  fontSize: "1.45rem",
                  lineHeight: 1.4,
                }}
              >
                &ldquo;One decision can alter the course of your entire
                life.&rdquo;
              </p>

              <p
                className="font-serif italic text-center"
                style={{
                  color: "var(--gold-deep)",
                  fontSize: "1.3rem",
                  lineHeight: 1.4,
                }}
              >
                Transformation doesn&apos;t begin on the 18th. It begins the
                moment you decide.
              </p>

              <div
                className="mx-auto w-12 h-px"
                style={{ background: "var(--gold-soft)" }}
                aria-hidden="true"
              />

              <p>
                You don&apos;t need to prepare anything. Just bring yourself,
                an open mind, and something to take notes with.
              </p>

              <p>
                And if you&apos;d like to get even more from the session, take
                a moment before we meet and ask yourself:
              </p>

              <p
                className="font-serif italic text-center px-4"
                style={{
                  color: "var(--ink)",
                  fontSize: "1.3rem",
                  lineHeight: 1.5,
                }}
              >
                &ldquo;If I stopped trying so hard to make life happen, what
                might become possible?&rdquo;
              </p>

              <p>I can&apos;t wait to share this experience with you.</p>

              <p>See you soon.</p>

              <div className="pt-2">
                <p
                  className="italic"
                  style={{ color: "var(--ink-soft)", fontSize: "1.05rem" }}
                >
                  With love,
                </p>
                <p
                  className="font-script mt-1"
                  style={{
                    color: "var(--gold-deep)",
                    fontSize: "3rem",
                    lineHeight: 1,
                  }}
                >
                  Persephone
                </p>
              </div>
            </div>

            <p
              className="mt-14 font-serif italic"
              style={{ color: "var(--gold-deep)", fontSize: "1.1rem" }}
            >
              Do Less. Be More.
            </p>

            <div className="mt-10">
              <Link
                to="/"
                className="text-sm tracking-wider text-[color:var(--ink-soft)] hover:text-[color:var(--gold-deep)] transition-colors"
                data-testid="thank-you-back-link"
              >
                ← Back to the masterclass page
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default ThankYou;
